import React, { useState } from "react";
import CustomFieldModal from "./CustomFieldModal";
import useCustomField from "../../../../../hooks/useCustomField/UseCustomField";
import { MdDeleteOutline, MdOutlineEdit } from "react-icons/md";
import EditCustomFieldModal from "./EditCustomFieldModal";
import useUpdateCustomField from "../../../../../hooks/useCustomField/useUpdateCustomField";
import useEditCustomField from "../../../../../hooks/useCustomField/useEditCustomField";
import DeleteConfirmationModal from "./DeleteConfirmationModal";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import FieldEditModal from "./FieldEditModal/FieldEditModal";

const OtherBusinessDetails = ({
  dynamicFields = [],
  hidden,
  onFieldChange, // Accept onFieldChange prop from parent
  require,
  data,
  setData,
  Message,
}) => {
  const [showModal, setShowModal] = useState(false);
  const { submitCustomField } = useCustomField();
  const { updateCustomField } = useUpdateCustomField();
  const [division, setDivision] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [fieldToDelete, setFieldToDelete] = useState(null);
  const [message, setMessage] = useState({ type: "", text: "" }); // State for success/error messages
  const apiUrls = process.env.REACT_APP_API_URLS;

  const {
    showEditModal,
    selectedField,
    handleOpenEditModal,
    handleCloseEditModal,
    handleSubmitUpdateField,
  } = useEditCustomField();

  // Handle form submission for adding a new field
  const handleSubmit = async (data) => {
    const result = await submitCustomField(data);
    if (result.success) {
      toast.success("Field is Added Succefully", {
        position: "top-right",
        autoClose: 600,
      });

      setShowModal(false);
      setTimeout(() => {
        window.location.reload();
      }, 700);
    } else {
      toast.error(result.message, {
        position: "top-right",
        autoClose: 1000,
      });
      setShowModal(false);
    }
  };

  // Open Add Field Modal
  const handleOpenModal = () => {
    setDivision("Other Business Details");
    setShowModal(true);
  };

  // Open Delete Confirmation Modal
  const handleDeleteField = (field) => {
    setFieldToDelete(field);
    setShowDeleteModal(true);
  };

  // Confirm deletion of the field
  const handleConfirmDelete = async () => {
    if (fieldToDelete) {
      try {
        const response = await axios.delete(
          `${apiUrls}/buyer_settings/custom-fields/${fieldToDelete.id}/`
        );

        if (response.status === 204 || response.status === 200) {
          setMessage({ type: "success", text: "Field deleted successfully!" });
          window.location.reload();
        } else {
          setMessage({ type: "error", text: "Failed to delete the field." });
        }
      } catch (error) {
        setMessage({
          type: "error",
          text: "An error occurred while deleting the field.",
        });
      } finally {
        setShowDeleteModal(false);
        setFieldToDelete(null);
      }
    }
  };

  // Close Delete Confirmation Modal
  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setFieldToDelete(null);
  };

  // Handle input changes and notify parent
  const handleInputChange = (e, field) => {
    const { value } = e.target;
    // Update the specific field in the data object
    setData((prevData) => ({
      ...prevData,
      [field.column_name]: value,
    }));
    onFieldChange(field.column_name || field.name, value); // Notify parent of the change
  };

       const [isEditModalOpen, setEditModalOpen] = useState(false)
  const [formData, setFormData] = useState({
    label: '',
    placeholder: '',
    type: 'required',
  });

  const handleSave = () => {
    console.log("Form Data Saved:", formData);
    setEditModalOpen(false);
  };

  return (
    <>
      <div className="border border-gray-300 shadow-lg rounded-md p-6">
        <h2 className="text-lg font-semibold mb-6">
          <span className="underline">Other Business Details :</span>
        </h2>

        {/* Display success/error messages */}
        {/* {message.text && (
          <div
            className={`p-2 mb-4 rounded-md ${
              message.field_type === "success"
                ? "bg-green-100 text-green-700"
                : "bg-red-100 text-red-700"
            }`}
          >
            {message.text}
          </div>
        )} */}

        <form className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Static Fields */}
          <div>
            <div className="flex items-center justify-between">
            <label htmlFor="tax_id" className="block font-medium">
              Tax ID
            </label>
             {Message === "dont show icons" ? (
                <></>
              ) : (<div className="flex items-center gap-5">
                <span onClick={() => {setFormData({label:"Tax ID",placeholder:"Enter Your Tax ID"});;setEditModalOpen(true)}} className="text-gray-400 cursor-pointer">✎</span>
                <span className="text-gray-400 cursor-pointer scale-150">x</span>
              </div>)}
            </div>
            <input
              type="text"
              id="tax_id"
              name="tax_id" // Add a name for the field
              placeholder="Enter your Tax ID"
              className="mt-1 block w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:border-gray-400"
              onChange={(e) => handleInputChange(e, { column_name: "tax_id" })} // Notify parent of changes
              disabled={require}
              readOnly={require}
            />
          </div>

          <div>
            <div className="flex items-center justify-between">
            <label htmlFor="preferred_currency" className="block font-medium">
              Preferred Currency
            </label>
             {Message === "dont show icons" ? (
                <></>
              ) : (<div className="flex items-center gap-5">
                <span onClick={() => {setFormData({label:"Preffered Currency",placeholder:"Select Preffered Curreny"});;setEditModalOpen(true)}} className="text-gray-400 cursor-pointer">✎</span>
                <span className="text-gray-400 cursor-pointer scale-150">x</span>
              </div>)}
            </div>
            <select
              id="preferred_currency"
              name="preferred_currency" // Add a name for the field
              className="mt-1 block w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:border-gray-400"
              onChange={(e) =>
                handleInputChange(e, { column_name: "preferred_currency" })
              } // Notify parent of changes
              disabled={require}
              readOnly={require}
            >
              <option>Select Preferred Currency</option>
              <option value="USD">USD</option>
              <option value="EURO">EURO</option>
              <option value="INR">INR</option>
            </select>
          </div>

          <div>
            <div className="flex items-center justify-between">
            <label htmlFor="companyType" className="block font-medium">
              Type of Company
            </label>
             {Message === "dont show icons" ? (
                <></>
              ) : (<div className="flex items-center gap-5">
                <span onClick={() => {setFormData({label:"Type of Company",placeholder:"Select Type of Company"});;setEditModalOpen(true)}} className="text-gray-400 cursor-pointer">✎</span>
                <span className="text-gray-400 cursor-pointer scale-150">x</span>
              </div>)}
            </div>
            <select
              id="companyType"
              name="companyType" // Add a name for the field
              className="mt-1 block w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:border-gray-400"
              onChange={(e) =>
                handleInputChange(e, { column_name: "companyType" })
              } // Notify parent of changes
              disabled={require}
              readOnly={require}
            >
              <option>Select Type of Company</option>
              <option value="Individual">Individual</option>
              <option value="Single Man Company">Single Man Company</option>
              <option value="Proprietorship">Proprietorship</option>
              <option value="Partnership">Partnership</option>
              <option value="Private Limited">Private Limited</option>
              <option value="Public Limited">Public Limited</option>
              <option value="Government">Government</option>
              <option value="NGO">NGO</option>
            </select>
          </div>

          <div>
            <div className="flex items-center justify-between">
            <label
              htmlFor="year_of_incorporation"
              className="block font-medium"
            >
              Year of Incorporation
            </label>
             {Message === "dont show icons" ? (
                <></>
              ) : (<div className="flex items-center gap-5">
                <span onClick={() => {setFormData({label:"Year of Incorporation",placeholder:"Enter Year of Incorporation"});;setEditModalOpen(true)}} className="text-gray-400 cursor-pointer">✎</span>
                <span className="text-gray-400 cursor-pointer scale-150">x</span>
              </div>)}
            </div>
            <input
              type="text"
              id="year_of_incorporation"
              name="year_of_incorporation" // Add a name for the field
              placeholder="Enter Year of Incorporation"
              className="mt-1 block w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:border-gray-400"
              onChange={(e) =>
                handleInputChange(e, { column_name: "year_of_incorporation" })
              } // Notify parent of changes
              disabled={require}
              readOnly={require}
            />
          </div>

          <div>
            <div className="flex items-center justify-between">
            <label htmlFor="yearly_revenue" className="block font-medium">
              Yearly Revenue
            </label>
             {Message === "dont show icons" ? (
                <></>
              ) : (<div className="flex items-center gap-5">
                <span onClick={() => {setFormData({label:"Yearly Revenue",placeholder:"Select Yearly Revenue"});;setEditModalOpen(true)}} className="text-gray-400 cursor-pointer">✎</span>
                <span className="text-gray-400 cursor-pointer scale-150">x</span>
              </div>)}
            </div>
            <select
              id="yearly_revenue"
              name="yearly_revenue" // Add a name for the field
              className="mt-1 block w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:border-gray-400"
              onChange={(e) =>
                handleInputChange(e, { column_name: "yearly_revenue" })
              } // Notify parent of changes
              disabled={require}
              readOnly={require}
            >
              <option>Select Yearly Revenue</option>
              <option value="Less than 1 million USD">
                Less than 1 million USD
              </option>
              <option value="1 to 10 million USD">1 to 10 million USD</option>
              <option value="50 to 100 million USD">
                50 to 100 million USD
              </option>
              <option value="100 to 500 million USD">
                100 to 500 million USD
              </option>
              <option value="More than 500 million USD">
                More than 500 million USD
              </option>
            </select>
          </div>

          <div>
            <div className="flex items-center justify-between">
            <label htmlFor="number_of_employees" className="block font-medium">
              Number of Employees
            </label>
             {Message === "dont show icons" ? (
                <></>
              ) : (<div className="flex items-center gap-5">
                <span onClick={() => {setFormData({label:"Number of Employess",placeholder:"Select no of Employess"});;setEditModalOpen(true)}} className="text-gray-400 cursor-pointer">✎</span>
                <span className="text-gray-400 cursor-pointer scale-150">x</span>
              </div>)}
            </div>
            <select
              id="number_of_employees"
              name="number_of_employees" // Add a name for the field
              className="mt-1 block w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:border-gray-400"
              onChange={(e) =>
                handleInputChange(e, { column_name: "number_of_employees" })
              } // Notify parent of changes
              disabled={require}
              readOnly={require}
            >
              <option>Select No. of Employees</option>
              <option value="1 to 20">1 to 20</option>
              <option value="21 to 100">21 to 100</option>
              <option value="101 to 500">101 to 500</option>
              <option value="More than 500">More than 500</option>
            </select>
          </div>

          {/* Dynamic Fields Rendering */}
          {dynamicFields &&
            dynamicFields.map((field) => {
              // Check if the field is valid and has the required properties
              if (!field || !field.field_label) {
                return null; // Skip rendering this field if it's invalid
              }

              return (
                field.division == "Other Business Details" && (
                  <div key={field.column_name}>
                    <div className="flex justify-between">
                      <label className="block">
                        {field.field_label
                          ? field.field_label.replace(/_/g, " ")
                          : "Unlabeled Field"}
                        {field.is_required && (
                          <span className="text-red-500">*</span>
                        )}
                      </label>
                      <div
                        className={`gap-[5px] ${hidden ? "hidden" : "flex"}`}
                      >
                        <button
                          className="color-[#979797]"
                          type="button"
                          onClick={() => handleOpenEditModal(field)}
                        >
                          <MdOutlineEdit className="color-[#979797]" />
                        </button>
                        <button
                          className="color-[#979797]"
                          type="button"
                          onClick={() => handleDeleteField(field)}
                        >
                          <MdDeleteOutline className="color-[#979797]" />
                        </button>
                      </div>
                    </div>

                    {/* Render Inputs Based on Type */}
                    {field.field_type === "text" ||
                    field.field_type === "date" ? (
                      <input
                        type={field.field_type}
                        value={data?.[field.column_name] || ""}
                        name={field.column_name} // Use column_name as the field name
                        placeholder={field.placeholder || ""}
                        className="mt-1 block w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:border-gray-400"
                        onChange={(e) => handleInputChange(e, field)} // Notify parent of changes
                        disabled={require}
                        readOnly={require}
                      />
                    ) : field.field_type === "radio" ||
                      field.field_type === "checkbox" ? (
                      field.options.split(",").map((option) => (
                        <div
                          key={option}
                          className="flex items-center space-x-2 mt-1"
                        >
                          <input
                            type={field.field_type}
                            id={option}
                            name={field.column_name}
                            // value={option}
                            value={data?.[field.column_name] || { option }}
                            onChange={(e) => handleInputChange(e, field)} // Notify parent of changes
                            disabled={require}
                            readOnly={require}
                          />
                          <label htmlFor={option}>{option}</label>
                        </div>
                      ))
                    ) : field.field_type === "dropdown" ? (
                      <select
                        name={field.column_name} // Use column_name as the field name
                        className="mt-1 block w-full p-2 border border-gray-300 rounded-md focus:outline-none"
                        onChange={(e) => handleInputChange(e, field)} // Notify parent of changes
                        disabled={require}
                        readOnly={require}
                      >
                        <option disabled>
                          Select {field.column_name.replace(/_/g, " ")}
                        </option>
                        {field.options.split(",").map((option) => (
                          <option key={option} value={option}>
                            {option}
                          </option>
                        ))}
                      </select>
                    ) : null}
                  </div>
                )
              );
            })}
        </form>

        <div className={`${hidden ? hidden : "flex"} justify-end py-5`}>
          <button
            className="bg-[#ECECEC] text-[#979797] p-2 rounded-[5px]"
            onClick={handleOpenModal}
          >
            Add Field
          </button>
        </div>
      </div>

      <FieldEditModal
        isOpen={isEditModalOpen}
        onClose={() => setEditModalOpen(false)}
        onSave={handleSave}
        formData={formData}
        setFormData={setFormData}
        content={"Other Business Details"}
      />

      {/* Add Custom Field Modal */}
      <CustomFieldModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onSubmit={handleSubmit}
        division="Other Business Details" // Set division value here
      />

      {/* Edit Custom Field Modal */}
      <EditCustomFieldModal
        isOpen={showEditModal}
        onClose={handleCloseEditModal}
        onSubmit={handleSubmitUpdateField}
        fieldData={selectedField}
      />

      {/* Delete Confirmation Modal */}
      <DeleteConfirmationModal
        isOpen={showDeleteModal}
        onClose={handleCloseDeleteModal}
        onConfirm={handleConfirmDelete}
      />
      <ToastContainer />
    </>
  );
};

export default OtherBusinessDetails;
